export default "/images/icon-views.svg?52f17572d8af928c443bc1600c07839d";